import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { TaalIcon } from "../../atoms/icons/TaalIcon";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string | null>;
export const Taal = (props: AllProps) => {
    return (<Caption {...props} caption={props.label || "Gesproken Taal"} icon={<TaalIcon />}>
        {props.value}
    </Caption>)
}

